const config = {
    'API_URL': "https://hh-tgc12p3-greattogo.herokuapp.com/api",
    'BASE_URL': "https://greattogo-foods.netlify.app/",
    'REFRESH_INTERVAL':  3600000, // 840000
    'EMAILJS_ID': 'user_Fvc9zxXoPQStYaW3e3DN0'
}

export default config;